'use client';

import { paths } from '@/constants/paths';
import { CartEmptySection } from '@/ui/components/layout/cart/CartEmptySection';
import CartItemsList from '@/ui/components/layout/cart/CartItemsList';
import { cartPageVariant } from '@/ui/components/layout/cart/CartItem/types/cartItemVariants';
import CartSummary from '@/ui/components/layout/cart/CartSummary';
import { CartValueSection } from '@/ui/components/layout/cart/CartValueSection';
import Button from '@/ui/components/shared/Button';
import Spinner from '@/ui/components/shared/Spinner/Spinner';
import { useIsHydrated } from '@/ui/hooks/useIsHydrated';
import useUser from '@/ui/providers/userProvider';
import { useCartStore } from '@/ui/store/cart';
import { useTrackViewCart } from '@/ui/hooks/tracking/use-track-view-cart';
import { MathHelper } from '@/utils/math-helper';
import { useTranslations } from 'next-intl';
import React from 'react';

export default function CartPage() {
  const { items, isEmpty, getPriceVariant, getTotalAfterDiscount } = useCartStore();
  const { session } = useUser();
  const isHydrated = useIsHydrated();
  const t = useTranslations('CartCheckoutButton');

  // GA4 tracking
  useTrackViewCart(items, {
    enabled: isHydrated && !isEmpty(),
    currency: getPriceVariant()?.currency,
    value: MathHelper.round(getTotalAfterDiscount()),
  });

  return (
    <div className="mx-auto max-w-screen-2xl px-3 sm:px-8">
      <div className=" mx-auto max-w-5xl pb-4 sm:py-4 md:py-16">
        {isHydrated ? (
          <div>
            {!isEmpty() && <CartValueSection isOnCartPage />}
            {isEmpty() && <CartEmptySection session={session} isOnCartPage />}
            {!isEmpty() && <CartItemsList cartItems={items} variant={cartPageVariant} />}
            {!isEmpty() && (
              <div className="w-full border-t border-neutral-10">
                <div className=" ml-auto max-w-sm">
                  <CartSummary isOnCartPage />
                  <Button href={paths.checkout} className="mx-4 mt-4">
                    {t('CHECK OUT')}
                  </Button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
}
